<template>
	<div class="mb-4">
		<p class="mb-0 text-lg font-semibold">
			<slot />
		</p>
		<p v-if="$slots.sub" class="mb-0 mt-2"><slot name="sub" /></p>
	</div>
</template>
